import React, { useState } from "react";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../components/ui/InputSearch/InputSearch";

const checkByOptions = [
  {
    id: "test1",
    name: "상품명",
  },
  {
    id: "test2",
    name: "주문번호",
  },
  {
    id: "test3",
    name: "주문자(담당자)",
  },
  {
    id: "test4",
    name: "사업자등록번호",
  },
  {
    id: "test5",
    name: "대표자/담당자 연락처",
  },
];

function Filter(props) {
  const { onFilter, onSubmitFilter, onResetFilter } = props;

  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      from: value?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      to: value?.unix(),
    });
  };

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="mb-8 mt-4 rounded-[4px] shadow-lg"
    >
      <div className="flex items-center px-5 pt-5 pb-[10px]">
        <div className="flex items-center">
          <span className="w-24">신청처리 현황</span>
          <div className="gap-4 flex">
            <div className="items-center flex">
              <input
                type="radio"
                className="mr-1.5 cursor-pointer accent-black"
                name="processingStatus"
              />
              <span>전체</span>
            </div>
            <div className="items-center flex">
              <input
                type="radio"
                className="mr-1.5 cursor-pointer accent-black"
                name="processingStatus"
              />
              <span>발행대기</span>
            </div>
            <div className="items-center flex">
              <input
                type="radio"
                className="mr-1.5 cursor-pointer accent-black"
                name="processingStatus"
              />
              <span>발행완료</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center px-5 pb-5">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center w-1/2">
            <span className="w-24">검색</span>
            <div className="flex gap-4">
              <Dropdown
                width="w-28"
                placeholder="상품명"
                textColor="text-black"
                positionDropdown="top-10"
                dropdownWidth="w-36"
                options={checkByOptions}
                onClickItem={(id) => onFilter({ check_by: id })}
              />
              <InputSearch
                onChange={(value) => onFilter({ productGroupName: value })}
              />
            </div>
          </div>

          <div className="flex items-center gap-[8px] w-1/2">
            <span className="w-12">기간</span>
            <InputDate
              value={discountStartDate}
              onChange={onChangeDiscountStartDate}
              defaultValue={discountStartDate}
            />
            <span className="text-secondary-grey">-</span>
            <InputDate
              value={discountEndDate}
              onChange={onChangeDiscountEndDate}
              defaultValue={discountEndDate}
            />
          </div>
        </div>
      </div>
      <div className="pb-2.5 w-full border-t border-disable-grey " />
      <div className="pb-2.5 flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          paddingButton="p-[4px]"
          width="w-[7rem]"
          className="border border-secondary-grey"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilter}
          paddingButton="p-[4px]"
          width="w-[7rem]"
          className="border border-secondary-grey"
          text="필터 초기화"
        />
      </div>
    </div>
  );
}

export default Filter;
